/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingIdentitiesResult {
    getFixupPrototypeFunction() { return BillingIdentitiesResult.fixupPrototype; }

    static newInstance(model: Partial<BillingIdentitiesResult>): BillingIdentitiesResult {
        let obj = Object.assign(new BillingIdentitiesResult(), model);
        BillingIdentitiesResult.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingIdentitiesResult>): BillingIdentitiesResult {
        if (!model) return null;
        return BillingIdentitiesResult.newInstance(<BillingIdentitiesResult> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingIdentitiesResult) {
        if (!obj) return;

        models.BillingIdentitiesResult.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingIdentitiesResult): boolean {
        Object.setPrototypeOf(obj, BillingIdentitiesResult.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.identity) {
            models.BillingLineItemIdentityPlus.fixupPrototype(this.identity);
        }
    }

    /**
     * Identity of the line item group, including tags
     */
    identity: models.BillingLineItemIdentityPlus;

}
